import { SVGProps, Ref, forwardRef } from 'react';

export const BarsOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M14 4.4H2V3h12z" fill="currentColor" />
            <path d="M14 8.7H2V7.3h12z" fill="currentColor" />
            <path d="M2 13h12v-1.4H2z" fill="currentColor" />
        </g>
    </svg>
));
BarsOutlinedSize16Glyph.displayName = 'BarsOutlinedSize16Glyph';
